import { Component, OnInit, OnDestroy, AfterViewInit, Input, ViewEncapsulation, ViewChild, ElementRef, NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../auth/auth.service';
import { fromEvent, Subscription } from 'rxjs';
import { MenuItem, MenuItemSeparator } from '../../widgets/nested-menu/nested-menu.component';
import { MenuItem as PrimeMenuItem } from 'primeng/api';
import { NavigationService } from '../../navigation/navigation.service';
import { UserService } from '../../../users/shared/user.service';
import { WlEventsToolbarBroadcastService, WlEventsToolbarEventTypeEnum } from '../toolbars/module/events/broadcast/index';
import { FeatureService } from '../../feature/feature.service';
import { FeatureNameEnum } from '../../feature/feature-name.enum';
import { LicenseService } from '../../license/license.service';
import { LicenseTypeEnum } from '../../license/license-type.enum';
import { ApiService } from '../../api/api.service';
import { ConfigService } from '../../../config/shared/config.service';
import { AppContext } from '../../../config/shared/app-context.model';
import { CreditCardGatewayService } from '../../../revenue/shared/credit-card-gateway/credit-card-gateway.service';
import { HttpRequestItemsComponent } from '../../../admin/http-request-items/http-request-items.component';
import { WeeblyService } from '../../../integrations/weebly/shared/weebly.service';
import { MailChimpSettingsService } from '../../../integrations/mailchimp/shared/mailchimp-settings.service';
import { AssociationInfo } from '../../../config/shared/association-info.model';
import {
  WlProfilesToolbarBroadcastService,
  WlProfilesToolbarEventTypeEnum,
  WlProfilesToolbarEvent,
} from '../toolbars/module/profiles/broadcast';
import { ProfileNewComponent } from '../../../profiles/profile-new/profile-new.component';
import { RouteHistoryService } from '../../services/route-history.service';
import { VerticalService } from '../../../vertical/shared/vertical.service';
import { VerticalTypeEnum } from '../../../vertical/shared/vertical-type.enum';
import { WlEventsV4ToolbarBroadcastService, WlEventsV4ToolbarEventTypeEnum } from '../toolbars/module/events-v4/broadcast';
import { EventsV4NewComponent } from 'src/app/events-v4/new/events-v4-new.component';
import { EventsNewComponent } from 'src/app/events/new/events-new.component';
import { AuthUserInfo } from '../../auth/auth-user-info.model';
import { UserDto } from 'src/app/users/shared/dto/user.dto';
import { UtilService } from '../../util/util.service';
import { TenantSelectionDto } from 'src/app/users/shared/dto/tenant-selection.dto';
import { SelectItem } from 'primeng/api';
import { TokenService } from '../../auth/token.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'wl-top-nav',
  templateUrl: 'top-nav.component.html',
  styleUrls: ['top-nav.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [UserService, VerticalService],
  host: {
    '(document:click)': 'onDocumentClick($event)',
  },
  standalone: false,
})
export class TopNavComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() public sectionName: string = '';

  public _authService: AuthService;
  public _translationService: TranslateService;
  public _navigationService: NavigationService;
  public _userService: UserService;
  public _creditCardGatewayService: CreditCardGatewayService;
  public _subscriptions: Array<Subscription> = [];

  public userAccessLevelEvents: number;
  public userAccessLevelReports: number;
  public userAccessLevelAdmin: number;
  public userAccessLevelSend_Mass_Communicatons: number;
  public userAccessLevelWebContentManagmeent: number;
  public userAccessLevelRevenue: number;

  public hideCreateEventMenuItem: boolean;
  public hideReportsMenuItem: boolean;
  public hideAdminMenuItem: boolean;
  public hasBenefitManagement: boolean;
  public hideRevenueMenuItem: boolean;
  public hideCommunicationsMenu: boolean;
  public hideWeeblyLogin: boolean;
  public hideMailChimp: boolean;
  public hideFormBuilder: boolean;
  public hideSelectProfiles: boolean;
  public hideEPly: boolean;
  public hideAddMember: boolean;
  public hideAddProspect: boolean;
  public hideWMSMenuItem: boolean;
  public hideNahbExportMenuItem: boolean;
  public hideSalesOpportunities = true;
  public hideCommittees = true;
  public hideContactRecords = true;
  public hasAdminModuleRole = false;
  public hasSetPreferencesRole = false;
  public legacyDomain = '';
  public hasBigCommerce = false;
  public hideManageUsers = true;
  public hideAssociationInfo = true;
  public hideProfileMerge = true;
  public hideEcom: boolean = true;
  public hideProfileImport = true;
  public hidePostingTransactions = true;
  public hidePledgeCampaigns = true;
  public hideInsights = true;
  public hideQueryTool = true;
  public hidePublicLinks = true;

  public userName: string = '';
  public assocName: string;
  public showLogout: boolean = false;
  public topNav: Array<MenuItem>;
  public recentScreens: Array<MenuItem>;
  public menubarItems: PrimeMenuItem[] = [];
  public _customerId: number = 0;
  public _internal: boolean = false;
  public _legacyToken: string = '';
  public _legacyTokenLastUpdate: Date = new Date(1, 1, 1);
  public userNum: number = 0;
  public showForcePasswordUpdate = false;

  public showTenantSelection = false;
  public showTenantModal = false;
  public showTenantContextChangedModal = false;
  public tenantSelectionList: SelectItem[] = [];
  public tenantSearchResults: SelectItem[] = [];
  public selectedTenant: SelectItem;
  public isSwitching = false;

  // true while the menu/toolbar bar is stuck to the top of the viewport (banner scrolled out of view)
  public affix = false;

  private stuckObserver: IntersectionObserver;

  @ViewChild(EventsNewComponent, { static: false }) newEventDialog: EventsNewComponent;
  @ViewChild(EventsV4NewComponent, { static: false }) newEventv4Dialog: EventsV4NewComponent;
  @ViewChild(ProfileNewComponent) newProfileDialog: ProfileNewComponent;
  @ViewChild('httpRequestItemsDialog', { static: false }) httpRequestItemsDialog: HttpRequestItemsComponent;

  public constructor(
    authService: AuthService,
    translationService: TranslateService,
    navigationService: NavigationService,
    userService: UserService,
    creditCardGatewayService: CreditCardGatewayService,
    public _eventsToolbarBroadcastService: WlEventsToolbarBroadcastService,
    public _eventsV4ToolbarBroadcastService: WlEventsV4ToolbarBroadcastService,
    public _profilesToolbarBroadcastService: WlProfilesToolbarBroadcastService,
    public _apiService: ApiService,
    public _featureService: FeatureService,
    public _licenseService: LicenseService,
    public _configService: ConfigService,
    private _weeblyService: WeeblyService,
    public _mailChimpSettingsService: MailChimpSettingsService,
    private _routeHistoryService: RouteHistoryService,
    private _verticalTypeService: VerticalService,
    private _utilService: UtilService,
    private _tokenService: TokenService,
    private el: ElementRef,
    private _ngZone: NgZone
  ) {
    this._authService = authService;
    this._translationService = translationService;
    this._navigationService = navigationService;
    this._userService = userService;
    this._creditCardGatewayService = creditCardGatewayService;

    this.userAccessLevelEvents = 0;
    this.userAccessLevelReports = 0;
    this.userAccessLevelAdmin = 0;

    this.hideCreateEventMenuItem = true;
    this.hideReportsMenuItem = true;
    this.hideAdminMenuItem = true;
    this.hideRevenueMenuItem = true;
    this.hideWeeblyLogin = true;
    this.hideMailChimp = true;
    this.hideFormBuilder = false;
    this.hideEPly = true;

    this.userName = '';
    this.assocName = '';
    this.showLogout = false;
  }

  ngOnInit(): void {
    if (this._authService.currentUserIsAuthenticated()) {
      const token = this._tokenService.decodeJwt(this._authService.getAccessToken());
      this.showTenantSelection = true; //token.Payload['idp'] == 'okta';

      if (this.showTenantSelection) {
        this._userService
          .getPersonifyTenantList()
          .then((data: TenantSelectionDto[]) => {
            this.tenantSelectionList = data.map((tenant) => {
              return { label: tenant.TenantName, value: tenant.TenantId } as SelectItem;
            });
            if (this.tenantSelectionList.length <= 1) {
              this.showTenantSelection = false;
            }
          })
          .catch(() => {
            this.showTenantSelection = false;
          });
      }

      this._authService.getUserInfo().then((data: AuthUserInfo) => {
        this.showLogout = true;
        this.userName = data.name || 'WebLink User';
        this.legacyDomain = data.wli_tenant_https_url || '';
        //this.assocName = data.wli_associnfo_orgname;

        if (this._authService.getTenant() == 'Personify') {
          this.assocName = 'Personify, Inc.';
        } else {
          this._configService.getAssociationInfo().then((data: AssociationInfo) => {
            this.assocName = data.OrgName;
          });

          this.userNum = +data.wli_usernum;
          this._userService.get(this.userNum).then((userDto: UserDto) => {
            if (this._utilService.isNullEmptyOrWhitespace(userDto.PsfyIdpId)) {
              this.userNum = +data.wli_usernum;
              this._userService.get(this.userNum).then((userDto: UserDto) => {
                if (
                  this._utilService.isNullEmptyOrWhitespace(userDto.PsfyIdpId) &&
                  userDto.UserName.toLowerCase().indexOf('weblink') === -1 &&
                  userDto.UserName.toLowerCase().indexOf('atlas') === -1 &&
                  userDto.UserName.toLowerCase().indexOf('mctrade') === -1 &&
                  userDto.Email.toLowerCase().indexOf('personifycorp.com') === -1
                ) {
                  this.showForcePasswordUpdate = true;
                }
              });
            }
          });

          let p1 = this._userService.getCurrentUserSecurityElementAccessLevel('Events_Module').then((data: number) => {
            this.userAccessLevelEvents = data;
            if (this.userAccessLevelEvents == 0) {
              this.hideCreateEventMenuItem = true;
            } else {
              this.hideCreateEventMenuItem = false;
            }
          });
          let p2 = this._userService.getCurrentUserSecurityElementAccessLevel('Reports_Module').then((data: number) => {
            this.userAccessLevelReports = data;
            if (this.userAccessLevelReports == 0) {
              this.hideReportsMenuItem = true;
            } else {
              this.hideReportsMenuItem = false;
            }
          });
          let p3 = this._userService.getCurrentUserSecurityElementAccessLevel('Admin_Module').then((data: number) => {
            this.userAccessLevelAdmin = data;
            if (this.userAccessLevelAdmin == 0) {
              this.hideAdminMenuItem = true;
            } else {
              this.hideAdminMenuItem = false;
            }
          });
          let p6 = this._userService.getCurrentUserSecurityElementAccessLevel('Send_Mass_Communicatons').then((accessLevel: number) => {
            this.userAccessLevelSend_Mass_Communicatons = accessLevel;
            if (this.userAccessLevelSend_Mass_Communicatons <= 1) {
              this.hideCommunicationsMenu = true;
            } else {
              this.hideCommunicationsMenu = false;
            }
          });
          let p4 = this._featureService.has(FeatureNameEnum.BenefitManagementMenu).then((data: boolean) => {
            this.hasBenefitManagement = data;
          });
          let p5 = this._configService.getAppContext().then((data: AppContext) => {
            this._customerId = data.CustomerId;
            this._internal = data.Internal;
          });

          let p7 = this._userService.getCurrentUserSecurityElementAccessLevel('Revenue_Module').then((accessLevel: number) => {
            this.userAccessLevelRevenue = accessLevel;
            if (this.userAccessLevelRevenue > 0) {
              this.hideRevenueMenuItem = false;
            }
          });

          let p8: any = this._userService.getCurrentUserSecurityElementAccessLevel('Web_Template_Manager').then((accessLevel: number) => {
            this.userAccessLevelWebContentManagmeent = accessLevel;

            let p8a = this._weeblyService.hasWeeblySettings().then((data: boolean) => {
              if (!data || this.userAccessLevelWebContentManagmeent < 2) {
                this.hideWeeblyLogin = true;
              } else {
                this.hideWeeblyLogin = false;
              }
            });
            return Promise.all([p8a]);
          });

          let p9 = this._mailChimpSettingsService.hasSettings().then((hasSettings: boolean) => {
            this.hideMailChimp = !hasSettings;
          });

          const p10 = this._configService.hasBetaFeatureEnabled('ePly').then((data: boolean) => {
            this.hideEPly = !Boolean(data);
          });

          const p11 = this._userService.getCurrentUserSecurityElementAccessLevel('Set_Profile_As_Member').then((accessLevel: number) => {
            this.hideAddMember = accessLevel < 1;
          });

          const p12 = this._userService.getCurrentUserSecurityElementAccessLevel('Set_Profile_As_Prospect').then((accessLevel: number) => {
            this.hideAddProspect = accessLevel < 1;
          });

          const p13 = this._featureService.has(FeatureNameEnum.SalesOpportunities).then((hasSalesOpps) => {
            this.hideSalesOpportunities = !hasSalesOpps;
          });

          const p14 = this._verticalTypeService.GetCurrentUserVerticalType().then((verticalType) => {
            this.hideWMSMenuItem = verticalType != VerticalTypeEnum.HBA;
            this.hideNahbExportMenuItem = verticalType != VerticalTypeEnum.HBA;
          });

          Promise.all([
            p1,
            p2,
            p3,
            p4,
            p6,
            p7,
            p8,
            p10,
            p11,
            p12,
            p13,
            p14,
            this._licenseService.has(LicenseTypeEnum.BigCommerce).then((data: boolean) => {
              this.hasBigCommerce = data;
            }),
            this._userService.getCurrentUserSecurityElementAccessLevel('Committees_Module').then((committeeAccessLevel) => {
              this.hideCommittees = committeeAccessLevel === 0;
            }),
            this._userService.getCurrentUserSecurityElementAccessLevel('Contacts_Module').then((contactRecordsAccessLevel) => {
              this.hideContactRecords = contactRecordsAccessLevel === 0;
            }),
            this._userService.getCurrentUserSecurityElementAccessLevel('Manage_Users').then((manageUsersAccess) => {
              this.hideManageUsers = manageUsersAccess === 0;
            }),
            this._userService.getCurrentUserSecurityElementAccessLevel('Admin_Module').then((adminAccessLevel) => {
              this.hasAdminModuleRole = adminAccessLevel > 0;
            }),
            this._userService.getCurrentUserSecurityElementAccessLevel('Set_Preferences').then((setPreferencesAccessLevel) => {
              this.hasSetPreferencesRole = setPreferencesAccessLevel > 0;
            }),
            this._userService.getCurrentUserSecurityElementAccessLevel('Association_Info').then((associationInfoAccess) => {
              this.hideAssociationInfo = associationInfoAccess === 0;
            }),
            this._userService.getCurrentUserSecurityElementAccessLevel('Delete_Profile').then((profileDeleteAccess) => {
              this.hideProfileMerge = profileDeleteAccess < 2;
            }),
            this._userService.getCurrentUserSecurityElementAccessLevel('Revenue_Module').then((pledgeCampaignsAccessLevel) => {
              this.hidePledgeCampaigns = pledgeCampaignsAccessLevel === 0;
            }),
            this._userService.getCurrentUserSecurityElementAccessLevel('Query Tool').then((queryToolAccessLevel) => {
              this.hideQueryTool = queryToolAccessLevel === 0;
            }),
            this._configService.hasBetaFeatureEnabled('Ecom').then((ecomEnabled) => {
              this.hideEcom = !ecomEnabled;
            }),
            this._userService.getCurrentUserSecurityElementAccessLevel('Report_Writer').then((accessLevel: number) => {
              if (accessLevel == 2) {
                this._configService.hasBetaFeatureEnabled('Insights').then((hasToggle: boolean) => {
                  this.hideInsights = !hasToggle;
                });
              }
            }),
          ]).then(() => {
            this.buildTopNav();
          });
        }
      });
    } else {
      this.showLogout = false;
      this.userName = '';
    }
    //}, 3000);

    this._subscriptions.push(
      fromEvent<StorageEvent>(window, 'storage').subscribe((event) => {
        if (event.key === 'wl-tenant' && event.newValue !== event.oldValue) {
          this.showTenantContextChangedModal = true;
        }
      })
    );

    this._subscriptions.push(
      this._eventsToolbarBroadcastService.subscribe((e) => {
        if (e.type == WlEventsToolbarEventTypeEnum.newEvent) this.openNewEventDialog();
      })
    );

    this._subscriptions.push(
      this._eventsV4ToolbarBroadcastService.subscribe((e) => {
        if (e.type == WlEventsV4ToolbarEventTypeEnum.newEvent) this.openNewEventV4Dialog();
      })
    );

    this._subscriptions.push(
      this._profilesToolbarBroadcastService.subscribe((e) => {
        if (e.type == WlProfilesToolbarEventTypeEnum.newProfile) this.openNewProfileDialog();
      })
    );
    this._subscriptions.push(
      this._routeHistoryService.navigationHistorySubscription$().subscribe((e) => {
        let dropdown = e.map((item) => {
          return { routerLink: item.url, title: item.title, noTranslate: true, queryParams: item.params } as MenuItem;
        });
        this.recentScreens = [
          {
            title: 'shared.container.top-nav.recent-screens',
            id: 1,
            dropdown: dropdown,
          },
        ];
        this.buildMenubarItems();
      })
    );
  }

  /**
   * The menu/toolbar bar is position: sticky (see top-nav.component.css), so layout needs no JS. This only
   * tracks whether it is stuck - true once the banner above it has scrolled fully out of view - so the
   * stuck-only pieces (brand mark, user/help nav) can show.
   */
  private initStuckObserver() {
    const bannerElement = this.el.nativeElement.querySelector('.header-container');
    if (!bannerElement) return;

    // IntersectionObserver callbacks run outside Angular's zone
    this.stuckObserver = new IntersectionObserver(([entry]) => {
      this._ngZone.run(() => (this.affix = !entry.isIntersecting));
    });
    this.stuckObserver.observe(bannerElement);
  }

  /**
   * clean up
   */
  public ngOnDestroy(): void {
    if (this._subscriptions) this._subscriptions.forEach((s) => s.unsubscribe());
    this.stuckObserver?.disconnect();
  }

  public buildTopNav = (): void => {
    this.topNav = new Array<MenuItem>();
    // let legacyDomain: string = '';
    let token: string = '';

    let promises: Promise<any>[] = [];
    let eventsV4Enabled = false;

    // promises.push(this._apiService.getDomainAsync().then(x => (this.legacyDomain = x)));
    promises.push(this.getUserLegacyToken().then((x) => (token = x)));
    promises.push(this._configService.hasBetaFeatureEnabled('EventsV4').then((data) => { eventsV4Enabled = !!data; }));

    Promise.all(promises).then(() => {
      const websiteDropdown: Array<MenuItem> = [
        {
          title: 'shared.container.top-nav.component.menu.communications.manage-web-content',
          routerLink: ['/web-content'],
        },
        {
          title: 'shared.container.top-nav.component.menu.communications.news-articles',
          routerLink: ['/news-articles'],
        },
        {
          title: 'shared.container.top-nav.component.menu.communications.coupons',
          routerLink: ['/coupons'],
        },
        {
          title: 'shared.container.top-nav.component.menu.communications.banner-ads',
          routerLink: ['/banner-ads'],
        },
        {
          title: 'shared.container.top-nav.component.menu.communications.ecommerce-items',
          routerLink: ['/ecommerce/item-list'],
          hidden: this.hideEcom,
        },
        {
          title: 'shared.container.top-nav.component.menu.communications.join-form-builder',
          routerLink: ['/form-builder/forms'],
          hidden: this.hideFormBuilder,
        },
        {
          title: 'shared.container.top-nav.component.menu.communications.public-links',
          routerLink: ['/public-links'],
        },
        {
          title: 'shared.container.top-nav.component.menu.communications.content-management-system',
          routerLink: ['/communications/content-management-link'],
          hidden: this.hideWeeblyLogin,
        },
      ];

      const hideWebsiteMenu = websiteDropdown.every((item) => item.hidden === true);

      this.topNav = [
        {
          title: 'shared.container.top-nav.component.menu.dashboard.header',
          routerLink: [''],
          id: 1,
        },
        {
          title: 'shared.container.top-nav.component.menu.profiles.header',
          id: 2,
          dropdown: [
            {
              title: 'shared.container.top-nav.component.menu.profiles.select',
              routerLink: ['/profiles'],
              id: 20,
            },
            {
              title: 'shared.container.top-nav.component.menu.profiles.change-request',
              routerLink: ['/profiles/manage-requests'],
              id: 30,
            },
            {
              title: 'shared.container.top-nav.component.menu.profiles.change-request',
              url:
                this.legacyDomain +
                '/external/wcpages/v12/webclient/Profile/update/manage-requests.aspx?token=' +
                encodeURIComponent(token),
              target: '_blank',
              refreshUrl: (me: MenuItem): void => {
                // freshen token
                this.getUserLegacyToken().then((freshToken) => {
                  me.url =
                    this.legacyDomain +
                    '/external/wcpages/v12/webclient/Profile/update/manage-requests.aspx?token=' +
                    encodeURIComponent(freshToken);
                });
              },
              hidden: true,
              id: 23,
            },
            {
              title: 'shared.container.top-nav.component.menu.profiles.front-desk-referrals',
              url: this.legacyDomain + '/external/wcpages/v12/webclient/Profile/frontdesk/index.aspx?token=' + encodeURIComponent(token),
              target: '_blank',
              refreshUrl: (me: MenuItem): void => {
                // freshen token
                this.getUserLegacyToken().then((freshToken) => {
                  me.url =
                    this.legacyDomain +
                    '/external/wcpages/v12/webclient/Profile/frontdesk/index.aspx?token=' +
                    encodeURIComponent(freshToken);
                });
              },
              id: 24,
            },
            {
              title: 'shared.container.top-nav.component.menu.profiles.add-a-member',
              hidden: this.hideAddMember,
              click: () => {
                this._profilesToolbarBroadcastService.broadcast(new WlProfilesToolbarEvent(WlProfilesToolbarEventTypeEnum.newProfile));
                this._navigationService.navigateToProfileFinder();
              },
              id: 25,
            },
            {
              title: 'shared.container.top-nav.component.menu.profiles.add-a-prospect',
              hidden: this.hideAddProspect,
              //just go to profile finder with the new profile dialog open per https://memberclicks.leankit.com/card/901269842
              click: () => {
                this._profilesToolbarBroadcastService.broadcast(new WlProfilesToolbarEvent(WlProfilesToolbarEventTypeEnum.newProfile));
                this._navigationService.navigateToProfileFinder();
              },
              id: 26,
            },
            {
              title: 'shared.container.top-nav.component.menu.profiles.drop-members',
              routerLink: ['/profiles/drop-members'],
              id: 40,
            },
            {
              title: 'shared.container.top-nav.component.menu.profiles.benefit-management',
              id: 22,
              hidden: !this.hasBenefitManagement,
              click: () => {
                this._navigationService.navigateToBenefitsManagement();
              },
            },
            {
              title: 'shared.container.top-nav.component.menu.profiles.sales-opportunities',
              id: 29,
              hidden: this.hideSalesOpportunities,
              click: () => {
                this._navigationService.navigateToSalesOpportunities();
              },
            },
            {
              title: 'shared.container.top-nav.component.menu.profiles.tasks',
              id: 29,
              click: () => {
                this._navigationService.navigateToTasks();
              },
            },
            {
              title: 'shared.container.top-nav.component.menu.profiles.committees',
              id: 29,
              hidden: this.hideCommittees,
              click: () => {
                this._navigationService.navigateToCommittees();
              },
            },
            {
              title: 'shared.container.top-nav.component.menu.profiles.contact-records',
              id: 29,
              hidden: this.hideContactRecords,
              click: () => {
                this._navigationService.navigateToContactRecords();
              },
            },
            {
              title: 'shared.container.top-nav.component.menu.profiles.WMS-Import',
              id: 29,
              hidden: this.hideWMSMenuItem,
              url: this.legacyDomain + '/external/wcpages/v12/webclient/vertical/hba/wmsimport.aspx?token=' + encodeURIComponent(token),
              target: '_blank',
              refreshUrl: (me: MenuItem): void => {
                // freshen token
                this.getUserLegacyToken().then((freshToken) => {
                  me.url =
                    this.legacyDomain +
                    '/external/wcpages/v12/webclient/vertical/hba/wmsimport.aspx?token=' +
                    encodeURIComponent(freshToken);
                });
              },
            },
          ],
        },
        {
          title: 'shared.container.top-nav.component.menu.events.header',
          id: 3,
          dropdown: [
            {
              title: 'shared.container.top-nav.component.menu.events.select',
              id: 31,
              routerLink: eventsV4Enabled ? ['/events-v4'] : ['/events'],
            },
            {
              title: 'shared.container.top-nav.component.menu.events.create',
              hidden: this.hideCreateEventMenuItem,
              id: 32,
              click: () => {
                this.openNewEventV4Dialog();
              },
            },
            {
              title: 'shared.container.top-nav.component.menu.events.community-event-submissions',
              hidden: this.hideCreateEventMenuItem,
              id: 71,
              routerLink: ['/events/submissions'],
            },
            {
              title: 'shared.container.top-nav.component.menu.events.eply',
              hidden: this.hideEPly,
              id: 33,
              click: () => {
                this.navigateToEPly();
              },
            },
            {
              title: 'shared.container.top-nav.component.menu.events.import-registrations',
              routerLink: ['/events/import-registrations'],
            },
          ],
        },
        {
          title: 'shared.container.top-nav.component.menu.revenue.header',
          id: 4,
          dropdown: [
            {
              title: 'shared.container.top-nav.component.menu.revenue.invoice-selector',
              id: 67,
              routerLink: ['/revenue/invoices'],
            },
            {
              title: 'shared.container.top-nav.component.menu.revenue.arc-builder',
              id: 66,
              routerLink: ['/revenue/pricing-calculations'],
            },
            {
              title: 'shared.container.top-nav.component.menu.revenue.generate-invoices',
              id: 68,
              routerLink: ['/revenue/invoice/generate'],
            },
            {
              title: 'shared.container.top-nav.component.menu.revenue.apply-payments',
              id: 69,
              click: () => {
                this.navigateToApplyPayment();
              },
            },
            {
              title: 'shared.container.top-nav.component.menu.revenue.credit-card-activity',
              id: 70,
              routerLink: ['/revenue/credit-card-activity'],
            },
            {
              title: 'shared.container.top-nav.component.menu.revenue.ecommerce-transactions',
              id: 72,
              routerLink: ['/revenue/ecommerce'],
              hidden: this.hideEcom,
            },
            {
              title: 'shared.container.top-nav.component.menu.revenue.pledge-campaigns',
              routerLink: ['/revenue/pledge-campaigns'],
              hidden: this.hidePledgeCampaigns,
              // hidden: true,
            },
            {
              title: 'shared.container.top-nav.component.menu.revenue.post-transactions',
              routerLink: ['/revenue/post-transactions'],
            },
            {
              title: 'shared.container.top-nav.component.menu.revenue.posted-batches',
              routerLink: ['/revenue/posted-batches'],
            },
            {
              title: 'shared.container.top-nav.component.menu.revenue.gateway-resolution',
              routerLink: ['/revenue/gateway-resolution'],
              hidden: !this._authService.isUserPsfyStaff(),
            },
          ],
          hidden: this.hideRevenueMenuItem,
        },
        {
          title: 'shared.container.top-nav.component.menu.reports.header',
          dropdown: [
            {
              title: 'shared.container.top-nav.component.menu.reports.run-report',
              routerLink: ['/reports/runreport'],
            },
            {
              title: 'shared.container.top-nav.component.menu.reports.query-tool',
              routerLink: ['/reports/queries'],
              hidden: this.hideQueryTool,
            },
            {
              title: 'shared.container.top-nav.component.menu.reports.data-dictionary',
              routerLink: ['/reports/data-dictionary'],
            },
            {
              title: 'shared.container.top-nav.component.menu.reports.manage-report-files',
              routerLink: ['/reports/manage'],
            },
            {
              title: 'shared.container.top-nav.component.menu.reports.insights',
              hidden: this.hideInsights,
              click: () => {
                this.navigateInsights();
              },
            },
            {
              title: 'shared.container.top-nav.component.menu.reports.NAHB-export',
              routerLink: ['/reports/NAHB-export'],
              hidden: this.hideNahbExportMenuItem,
            },
          ],
          url: this.legacyDomain + '/external/wcpages/v12/webclient/report/index.aspx?token=' + encodeURIComponent(token),
          id: 21,
          hidden: this.hideReportsMenuItem,
        },
        {
          title: 'shared.container.top-nav.component.menu.communications.header',
          hidden: this.hideCommunicationsMenu,
          dropdown: [
            {
              title: 'shared.container.top-nav.component.menu.communications.send-email',
              routerLink: ['/communications/message/draft/0'],
            },
            {
              title: 'shared.container.top-nav.component.menu.communications.message_admin',
              routerLink: ['/communications/message-admin'],
            },
            {
              title: 'shared.container.top-nav.component.menu.communications.mailchimp-sync',
              routerLink: ['/communications/mailchimp/sync'],
              hidden: this.hideMailChimp,
            },
          ],
        },
        {
          title: 'shared.container.top-nav.component.menu.website.header',
          hidden: hideWebsiteMenu,
          dropdown: websiteDropdown,
        },
        {
          title: 'shared.container.top-nav.component.menu.admin.header',
          hidden: this.hideAdminMenuItem,
          dropdown: [
            {
              title: 'shared.container.top-nav.component.menu.admin.manage-users',
              routerLink: ['/admin/users'],
              hidden: this.hideManageUsers,
            },
            {
              title: 'shared.container.top-nav.component.menu.admin.manage-codes',
              routerLink: ['/admin/codes'],
            },
            {
              title: 'shared.container.top-nav.component.menu.admin.global-settings',
              routerLink: ['/admin/global-settings'],
              hidden: !(this.hasSetPreferencesRole && this.hasAdminModuleRole),
            },
            {
              title: 'shared.container.top-nav.component.menu.admin.restore-profile',
              routerLink: ['/admin/restore-profile'],
            },
            {
              title: 'shared.container.top-nav.component.menu.admin.merge-profiles',
              routerLink: ['/profiles/merge-profiles'],
              hidden: this.hideProfileMerge,
            },
            {
              title: 'shared.container.top-nav.component.menu.admin.import-profiles',
              routerLink: ['/admin/import-profiles'],
            },
            {
              title: 'shared.container.top-nav.component.menu.admin.import-invoices',
              routerLink: ['/admin/import-invoices'],
            },
            {
              title: 'shared.container.top-nav.component.menu.admin.batch-drop-settings',
              routerLink: ['admin/batch-drop-settings'],
            },
            {
              title: 'shared.container.top-nav.component.menu.admin.member-drop-actions',
              routerLink: ['/admin/member-drop-actions'],
            },
            {
              title: 'shared.container.top-nav.component.menu.admin.membership-level-management',
              routerLink: ['/admin/membership-level-management'],
            },
            {
              title: 'shared.container.top-nav.component.menu.admin.profile-selector-settings',
              routerLink: ['admin/profile-selector-settings'],
            },
            {
              title: 'shared.container.top-nav.component.menu.big-commerce.integration-management',
              hidden: !this.hasBigCommerce,
              click: () => {
                this._navigationService.navigateToLegacyWebClientBigCommerceSetup();
              },
            },
            {
              title: 'shared.container.top-nav.component.menu.admin.configuration-settings',
              hidden: !(this.hasAdminModuleRole || this.hasSetPreferencesRole),
              click: () => {
                this._navigationService.navigateToLegacyWebClientConfigSettings();
              },
            },
            {
              title: 'shared.container.top-nav.component.menu.admin.association-info',
              hidden: !this.hasAdminModuleRole || this.hideAssociationInfo,
              routerLink: ['/admin/association-info'],
            },
          ],
        },
      ];
      this.buildMenubarItems();
    });
  };

  private buildMenubarItems(): void {
    if (!this.topNav?.length) return;

    const convertItems = (items: (MenuItem | MenuItemSeparator)[]): PrimeMenuItem[] => {
      return items
        .filter((item) => !(item as MenuItemSeparator).isSeparator)
        .map((item) => {
          const mi = item as MenuItem;
          const label = mi.noTranslate ? mi.title : this._translationService.instant(mi.title);

          const pItem: PrimeMenuItem = {
            label,
            visible: mi.hidden !== true,
          };

          if (mi.dropdown?.length) {
            pItem.items = convertItems(mi.dropdown);
          } else if (mi.routerLink) {
            pItem.routerLink = Array.isArray(mi.routerLink) ? mi.routerLink : [mi.routerLink];
            if (mi.queryParams) pItem.queryParams = mi.queryParams;
          } else if (mi.url) {
            pItem.url = mi.url;
            if (mi.target) pItem.target = mi.target;
          } else if (mi.click) {
            pItem.command = () => mi.click!();
          }

          return pItem;
        });
    };

    const items = convertItems(this.topNav);

    if (this.recentScreens?.length) {
      const recentItems = convertItems(this.recentScreens);
      if (recentItems.length) {
        recentItems[0].styleClass = 'recent-screens-nav-item';
      }
      items.push(...recentItems);
    }

    this.menubarItems = items;
  }

  public logout(): void {
    this._authService.sendUserToAuthServerLogout();
  }

  /**
   * closes topnav if clicked anywhere
   * @param $event
   */
  public onDocumentClick($event: any): void {
    const target = $event.target as HTMLElement;
    const isDropdownToggle = target.classList?.contains('dropdown-toggle');
    const isCaret = target.classList?.contains('caret');
    if (!isDropdownToggle && !isCaret) {
      document.querySelectorAll('.dropdown.open').forEach((el) => el.classList.remove('open'));
    }
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    const dropdown = (event.target as HTMLElement).closest('.dropdown');
    dropdown?.classList.toggle('open');
  }

  /**
   * init afix for this element
   */
  public ngAfterViewInit(): void {
    this.initStuckObserver();
  }

  /**
   * get user token. only get a fresh one every hour
   */
  public getUserLegacyToken(): Promise<string> {
    if (!this._legacyToken || new Date().getTime() - this._legacyTokenLastUpdate.getTime() > 1 * 59 * 60 * 1000) {
      return this._userService.getCurrentUserLegacyToken().then((newToken) => {
        this._legacyToken = newToken;
        this._legacyTokenLastUpdate = new Date();
        return newToken;
      });
    } else {
      return Promise.resolve(this._legacyToken);
    }
  }

  /**
   * open the new event dialog
   */
  public openNewEventDialog(): void {
    this.newEventDialog.reset();
    this.newEventDialog.open();
  }

  /**
   * open the new event dialog
   */
  public openNewEventV4Dialog(): void {
    this.newEventv4Dialog.reset();
    this.newEventv4Dialog.open();
  }

  /**
   * open the new profile dialog
   */
  public openNewProfileDialog(): void {
    this.newProfileDialog.reset();
    this.newProfileDialog.open();
  }

  public refreshLegacyUrlTokens(): void {
    if (this.topNav)
      this.topNav.forEach((item) => {
        if (item.refreshUrl) item.refreshUrl(item);
      });
  }
  public navigateToCreditCardProcessing = (): void => {
    this._navigationService.navigateCreditCardProcessing();
  };

  public navigateToCardConnectTransactions = (): void => {
    this._navigationService.navigateCardConnectTransactions();
  };

  public showHttpRequestItems = (): void => {
    this.httpRequestItemsDialog.show();
  };

  public handleIconClick = (): void => {
    let currentUrl = this._navigationService.getCurrentUrl();
    this._navigationService.navigateByUrl(currentUrl);
  };

  public searchTenants(searchEvent: any) {
    this.tenantSearchResults = this.tenantSelectionList?.filter((t) => t.label.toLowerCase().includes(searchEvent.query.toLowerCase()));
  }

  public tenantSelected(selectedTenant: any) {
    this.selectedTenant = selectedTenant.value;
  }

  public switchTenant() {
    if (this.selectedTenant) {
      this.isSwitching = true;
      const token = this._tokenService.decodeJwt(this._authService.getAccessToken());

      this._authService.setTenant(this.selectedTenant.value);
      this._userService
        .upsertOktaUser(token.Payload['sub'].toString())
        .then((userNum: number) => {
          if (userNum) {
            this._authService.setUserInfoForOktaUserWithTenantSelected(this.selectedTenant.value).then((success: boolean) => {
              if (success) {
                // Redundant belt-and-braces re-assertion (hotfix cb0faa3c). setUserInfo() no
                // longer clobbers wl-tenant on a successful reconciliation — the response is
                // required to agree with the already-selected tenant before anything is
                // written — so this write is a no-op on the value already stored. Retained
                // per the ATLAS-5608 PRD non-goal of not reverting the hotfix.
                this._authService.setTenant(this.selectedTenant.value);
                this.reloadApp();
              } else {
                // A rejected reconciliation resolves false rather than throwing, so the
                // outer .catch() below never runs. Without this the switcher stays
                // disabled showing "SWITCHING" with no way to retry — a degradation this
                // fix would otherwise introduce, since before ATLAS-5608 the switch always
                // proceeded. AuthService.setUserInfo() has already logged the reason via
                // LogService.warn; surfacing a visible error is R3.5's separate card.
                this.isSwitching = false;
              }
            });
          }
        })
        .catch((error: HttpErrorResponse) => {
          this.isSwitching = false;
        });
    }
  }

  private navigateToEPly() {
    const url = this._authService.getAuthServerUrlWithRedirect('https://events.eply.com/login/index.aspx');

    this._navigationService.popupSafeNavigate(url);
  }

  private navigateToApplyPayment() {
    this._navigationService.navigateToApplyPayment();
  }

  private navigateInsights() {
    this._navigationService.navigateToInsights();
  }

  public reloadApp(): void {
    window.location.reload();
  }
}
